export const SET_WAREHOUSES = "SET_WAREHOUSES";
export const SET_ACTIVE_WAREHOUSE = "SET_ACTIVE_WAREHOUSE";
export const SET_ACTIVE_FEED = "SET_ACTIVE_FEED";